import React from 'react'
import { injectIntl } from 'react-intl'

// intl.locale
const LangWrapper = ({onSwitch, intl}) => (
  <div className="lang-wrapper">
    {intl.locale==='fi'?
      <span>FIN</span>
      :
      <a href="/" onClick={(e) => {
        e.preventDefault();
        onSwitch();
      }}>FIN</a>
    }
    {intl.locale==='fi'?
      <a href="/" onClick={(e) => {
        e.preventDefault();
        onSwitch();
      }}>ENG</a>
      :
      <span>ENG</span>
    }
  </div>
)

export default injectIntl(LangWrapper);



// WEBPACK FOOTER //
// ./src/components/LangWrapper.js